import { render, staticRenderFns } from "./PublishView.vue?vue&type=template&id=56287e7b&scoped=true&"
import script from "./PublishView.vue?vue&type=script&lang=js&"
export * from "./PublishView.vue?vue&type=script&lang=js&"
import style0 from "./PublishView.vue?vue&type=style&index=0&id=56287e7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56287e7b",
  null
  
)

export default component.exports